<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div>
    <section class="content-header row">
        <div class="col-md-12 box-header">
            <h2 class="box-title">
                <strong>Manage Data</strong>
            </h2>
            <div class="pull-right box-tools"></div>
        </div>
    </section>
    <section class="content footerPosition">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="Location-List" class="card-layout card">
                    <h4 class="my-0">Location</h4>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div
                            [style.width]="
                                isInternalReadOnly || IsObjectNull(mapOriginDataModel.locationSelected) || user.role == roleName.Accounting
                                    ? '100%'
                                    : 'calc(100% - 80px)'
                            "
                        >
                            <ngx-select-dropdown
                                id="locationSelect"
                                name="originDropDown"
                                tabindex="0"
                                [config]="mapOriginDataModel.mapOriginConfig"
                                [multiple]="false"
                                [options]="mapOriginDataModel.serviceLocations"
                                [(ngModel)]="mapOriginDataModel.locationSelected"
                                (change)="changeLocation($event)"
                                (click)="clickDropDown('locationSelect')"
                            >
                            </ngx-select-dropdown>
                        </div>
                        <div *ngIf="!isInternalReadOnly" class="d-flex">
                            <ng-container *ngIf="user.role != roleName.Accounting">
                                <button
                                    *ngIf="!IsObjectNull(mapOriginDataModel.locationSelected)"
                                    id="editLocationButton"
                                    class="add-delete-button ml-3"
                                    data-target="#addLocation"
                                    data-toggle="modal"
                                    title="Edit Location Name"
                                    type="button"
                                    (click)="checkForAirportLocation(mapOriginDataModel.locationSelected)"
                                >
                                    <i class="fa fa-edit fa-lg"></i>
                                </button>
                            </ng-container>
                            <button
                                *ngIf="user.role != 'Coordinator'"
                                id="deleteLocationButton"
                                class="add-delete-button"
                                title="Delete Location"
                                type="button"
                                (click)="deleteSelectedLocation()"
                            >
                                <i class="fa fa-minus-circle fa-lg"></i>
                            </button>
                            <button
                                id="disableLocationButton"
                                class="add-delete-button"
                                title="Disable Location"
                                type="button"
                                (click)="disableSelectedLocation()"
                            >
                                <i class="fa fa-ban fa-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="user.role == roleName.Accounting" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="Display-Name-List" class="card-layout card">
                    <h4 class="my-0">Display Name</h4>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div class="w-100 pr-3">
                            <input
                                id="display-name"
                                class="form-control"
                                placeholder="Display Name"
                                type="text"
                                [(ngModel)]="locationDisplayName"
                            />
                        </div>
                        <div>
                            <button
                                id="save-display-name"
                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                                type="button"
                                [disabled]="!locationDisplayName"
                                (click)="addDisplayName()"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="user.role != roleName.Accounting" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="Equipment-List" class="card-layout card">
                    <h4 class="my-0">Equipment</h4>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div class="w-100">
                            <ngx-select-dropdown
                                *ngIf="!isShowAddEquipment"
                                id="equipmentSelect"
                                name="equipType"
                                tabindex="0"
                                [config]="equipmentDataModel.EquipmentSetting"
                                [multiple]="false"
                                [ngModelOptions]="{ standalone: true }"
                                [options]="equipmentDataModel.equipmentTypes"
                                [(ngModel)]="equipmentDataModel.selectedEquipment"
                                (click)="clickDropDown('equipmentSelect')"
                            >
                            </ngx-select-dropdown>
                            <input
                                *ngIf="isShowAddEquipment"
                                class="form-control"
                                name="addEquipmentType"
                                placeholder="Equipment Type"
                                type="text"
                                [(ngModel)]="addEquip.equipmentType"
                            />
                        </div>
                        <div *ngIf="!isShowAddEquipment && !isInternalReadOnly && user.role != 'Coordinator'" class="d-flex">
                            <button
                                id="addEquipmentButton"
                                class="add-delete-button"
                                title="Add Equipment Type"
                                type="button"
                                (click)="isShowAddEquipment = true"
                            >
                                <i class="fa fa-plus-circle fa-lg"></i>
                            </button>
                            <button
                                id="deleteEquipmentButton"
                                class="add-delete-button"
                                title="Delete Equipment Type"
                                type="button"
                                (click)="deleteJobType(serviceType.equipment)"
                            >
                                <i class="fa fa-minus-circle fa-lg"></i>
                            </button>
                        </div>
                        <div *ngIf="isShowAddEquipment" class="ml-2">
                            <button
                                id="addAddEquipmentButton"
                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                                type="button"
                                (click)="isShowAddEquipment = false; addJobType(serviceType.equipment)"
                            >
                                Add
                            </button>
                        </div>
                        <div *ngIf="isShowAddEquipment" class="ml-2 mt-1">
                            <button
                                id="cancelAddEquipmentButton"
                                class="add-delete-button"
                                title="Cancel Add Equipment Type"
                                type="button"
                                (click)="clearData(serviceType.equipment)"
                            >
                                <i class="fa fa-times-circle fa-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="Organ-List" class="card-layout card">
                    <h4 class="my-0">Organ</h4>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div class="w-100">
                            <ngx-select-dropdown
                                *ngIf="!isShowAddOrgan"
                                id="OrganSelect"
                                name="organType"
                                tabindex="0"
                                [config]="organDataModel.OrganSetting"
                                [multiple]="false"
                                [ngModelOptions]="{ standalone: true }"
                                [options]="organDataModel.organTypes"
                                [(ngModel)]="organDataModel.selectedOrgan"
                                (click)="clickDropDown('OrganSelect')"
                            >
                            </ngx-select-dropdown>
                            <input
                                *ngIf="isShowAddOrgan"
                                class="form-control"
                                name="addOrganType"
                                placeholder="Organ Type"
                                type="text"
                                [(ngModel)]="addEquip.equipmentType"
                            />
                        </div>
                        <div *ngIf="!isShowAddOrgan && !isInternalReadOnly && user.role != 'Coordinator'" class="d-flex">
                            <button
                                id="addOrganButton"
                                class="add-delete-button"
                                title="Add Organ Type"
                                type="button"
                                (click)="isShowAddOrgan = true"
                            >
                                <i class="fa fa-plus-circle fa-lg"></i>
                            </button>
                            <button
                                id="deleteOrganButton"
                                class="add-delete-button"
                                title="Delete Organ Type"
                                type="button"
                                (click)="deleteJobType(serviceType.organ)"
                            >
                                <i class="fa fa-minus-circle fa-lg"></i>
                            </button>
                        </div>
                        <div *ngIf="isShowAddOrgan" class="ml-2">
                            <button
                                id="addAddOrganButton"
                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 font-size-14 save-btn mt-1"
                                type="button"
                                (click)="isShowAddOrgan = false; addJobType(serviceType.organ)"
                            >
                                Add
                            </button>
                        </div>
                        <div *ngIf="isShowAddOrgan" class="ml-2 mt-1">
                            <button
                                id="cancelAddOrganButton"
                                class="add-delete-button"
                                title="Cancel Add Organ Type"
                                type="button"
                                (click)="clearData(serviceType.organ)"
                            >
                                <i class="fa fa-times-circle fa-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="Specimen-List" class="card-layout card">
                    <h4 class="my-0">Specimen</h4>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div class="w-100">
                            <ngx-select-dropdown
                                *ngIf="!isShowAddSpecimen"
                                id="specimenSelect"
                                name="specimenType"
                                tabindex="0"
                                [config]="specimenDataModel.SpecimenSetting"
                                [multiple]="false"
                                [ngModelOptions]="{ standalone: true }"
                                [options]="specimenDataModel.specimenTypes"
                                [(ngModel)]="specimenDataModel.selectedSpecimen"
                                (click)="clickDropDown('specimenSelect')"
                            >
                            </ngx-select-dropdown>
                            <input
                                *ngIf="isShowAddSpecimen"
                                class="form-control"
                                name="addSpecimenType"
                                placeholder="Specimen Type"
                                type="text"
                                [(ngModel)]="addEquip.equipmentType"
                            />
                        </div>
                        <div *ngIf="!isShowAddSpecimen && !isInternalReadOnly && user.role != 'Coordinator'" class="d-flex">
                            <button
                                id="addSpecimenButton"
                                class="add-delete-button"
                                title="Add Specimen Type"
                                type="button"
                                (click)="isShowAddSpecimen = true"
                            >
                                <i class="fa fa-plus-circle fa-lg"></i>
                            </button>
                            <button
                                id="deleteSpecimenButton"
                                class="add-delete-button"
                                title="Delete Specimen Type"
                                type="button"
                                (click)="deleteJobType(serviceType.specimen)"
                            >
                                <i class="fa fa-minus-circle fa-lg"></i>
                            </button>
                        </div>
                        <div *ngIf="isShowAddSpecimen" class="ml-2">
                            <button
                                id="addAddSpecimenButton"
                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                                type="button"
                                (click)="isShowAddSpecimen = false; addJobType(serviceType.specimen)"
                            >
                                Add
                            </button>
                        </div>
                        <div *ngIf="isShowAddSpecimen" class="ml-2 mt-1">
                            <button
                                id="cancelAddSpecimenButton"
                                class="add-delete-button"
                                title="Cancel Add Specimen Type"
                                type="button"
                                (click)="clearData(serviceType.specimen)"
                            >
                                <i class="fa fa-times-circle fa-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="State-List" class="card-layout card">
                    <h4 class="my-0">State</h4>
                    <hr class="hr-class mb-3" />
                    <div>
                        <ngx-select-dropdown
                            id="stateSelect"
                            name="state"
                            tabindex="0"
                            [config]="stateDataModel.StateSetting"
                            [multiple]="false"
                            [options]="stateDataModel.stateList"
                            (change)="getCityListBasedOnSelectedState($event)"
                            (click)="clickDropDown('stateSelect')"
                        >
                        </ngx-select-dropdown>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="City-List" class="card-layout card">
                    <div class="d-flex">
                        <h4 class="my-0">City</h4>
                        <span>
                            <i *ngIf="editCity == true" class="fa fa-spin fa-spinner text-color font-size-14 ml-2"></i>
                        </span>
                    </div>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div class="w-100">
                            <ngx-select-dropdown
                                *ngIf="!isShowAddCityOption"
                                id="citySelect"
                                name="city"
                                tabindex="0"
                                [config]="cityDataModel.CitySetting"
                                [multiple]="false"
                                [options]="cityDataModel.cityList"
                                [(ngModel)]="cityDataModel.selectedCity"
                                (click)="clickDropDown('citySelect')"
                            >
                            </ngx-select-dropdown>
                            <input
                                *ngIf="isShowAddCityOption"
                                class="form-control"
                                name="addSpecimenType"
                                placeholder="Enter City Name"
                                type="text"
                                [(ngModel)]="cityAdd.cityName"
                            />
                        </div>
                        <div *ngIf="isStateSelected == true && isShowAddCityOption == false && !isInternalReadOnly" class="d-flex">
                            <button
                                id="addCity"
                                class="add-delete-button"
                                title="Add City"
                                type="button"
                                (click)="isShowAddCityOption = true"
                            >
                                <i class="fa fa-plus-circle fa-lg"></i>
                            </button>
                            <button id="deleteCity" class="add-delete-button" title="Delete City" type="button" (click)="deleteCity()">
                                <i class="fa fa-minus-circle fa-lg"></i>
                            </button>
                        </div>
                        <div *ngIf="isShowAddCityOption == true" class="ml-2">
                            <button
                                id="addAddCity"
                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                                type="button"
                                (click)="isShowAddCityOption = false; addCity()"
                            >
                                Add
                            </button>
                        </div>
                        <div *ngIf="isShowAddCityOption == true" class="ml-2 mt-1">
                            <button
                                id="cancelAddSpecimenButton"
                                class="add-delete-button"
                                title="Cancel Add City"
                                type="button"
                                (click)="isShowAddCityOption = false; clearCityData()"
                            >
                                <i class="fa fa-times-circle fa-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="user.role != roleName.Accounting" class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div id="Additional-Equipment-List" class="card-layout card">
                    <h4 class="my-0">Additional Equipment Types</h4>
                    <hr class="hr-class mb-3" />
                    <div class="d-flex">
                        <div class="w-100">
                            <ngx-select-dropdown
                                *ngIf="!isShowAddAdditionalEquipmentType"
                                id="addAdditionalEquipmentType"
                                name="addAdditionalEquipmentType"
                                tabindex="0"
                                [config]="additionalEquipmentDataModel.additionalEquipmentDropdownSetting"
                                [multiple]="false"
                                [ngModelOptions]="{ standalone: true }"
                                [options]="additionalEquipmentDataModel.additionalEquipmentTypeList"
                                [(ngModel)]="additionalEquipmentDataModel.selectedAdditionalEquipmentType"
                                (click)="clickDropDown('addAdditionalEquipmentType')"
                            >
                            </ngx-select-dropdown>
                            <input
                                *ngIf="isShowAddAdditionalEquipmentType"
                                class="form-control"
                                name="addAdditionalEquipmentTypeInput"
                                placeholder="Add New Additional Equipment Type"
                                type="text"
                                [(ngModel)]="addEquip.equipmentType"
                            />
                        </div>
                        <div *ngIf="!isShowAddAdditionalEquipmentType && !isInternalReadOnly" class="d-flex">
                            <button
                                id="addAdditionalEquipmentTypeButton"
                                class="add-delete-button"
                                title="Add Additional Equipment Type"
                                type="button"
                                (click)="isShowAddAdditionalEquipmentType = true"
                            >
                                <i class="fa fa-plus-circle fa-lg"></i>
                            </button>
                            <button
                                id="deleteAdditionalEquipmentType"
                                class="add-delete-button"
                                title="Delete Additional Equipment Type"
                                type="button"
                                (click)="deleteAdditionalEquipmentType()"
                            >
                                <i class="fa fa-minus-circle fa-lg"></i>
                            </button>
                        </div>
                        <div *ngIf="isShowAddAdditionalEquipmentType" class="ml-2">
                            <button
                                id="closeAddAdditionalEquipmentType"
                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                                type="button"
                                (click)="isShowAddAdditionalEquipmentType = false; addAdditionalEquipmentType()"
                            >
                                Add
                            </button>
                        </div>
                        <div *ngIf="isShowAddAdditionalEquipmentType" class="ml-2 mt-1">
                            <button
                                id="cancelAddAdditionalEquipmentType"
                                class="add-delete-button"
                                title="Cancel Add Additional Equipment Type"
                                type="button"
                                (click)="isShowAddAdditionalEquipmentType = false"
                            >
                                <i class="fa fa-times-circle fa-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div id="addLocation" class="modal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button"><i class="fa fa-close"></i></button>
                <h4 class="modal-title">Edit Location</h4>
            </div>

            <form *ngIf="mapOriginDataModel.locationSelected != undefined" #addLocationForm="ngForm" name="addLocationForm">
                <div class="modal-body">
                    <div class="member-card">
                        <h4 class="filter-options">Address Details</h4>
                        <hr class="hr-class" />
                        <div class="col-md-12">
                            <div class="row form-group">
                                <label>Location Name</label><span class="text-danger"> * </span>

                                <input
                                    id="addressName"
                                    class="form-control"
                                    #addressName="ngModel"
                                    maxlength="255"
                                    name="addressName"
                                    placeholder="Location Name"
                                    required
                                    type="text"
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressName.invalid }"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.locationName"
                                />
                                <div *ngIf="addLocationForm.submitted && addressName.invalid" class="invalid-feedback">
                                    <div *ngIf="addressName.errors.required">
                                        <span class="text-danger">Location Name is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>Address Type</label><span class="text-danger"> * </span>
                                <select
                                    id="addressType"
                                    class="form-control"
                                    #addressType="ngModel"
                                    name="addressType"
                                    required
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressType.invalid }"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.locationAddressType"
                                >
                                    <option disabled selected [value]="undefined">Select Address Type</option>
                                    <option *ngFor="let address of AddressType" name="address_type" [value]="address">
                                        {{ address }}
                                    </option>
                                </select>
                                <div *ngIf="addLocationForm.submitted && addressType.invalid" class="invalid-feedback">
                                    <div *ngIf="addressType.errors.required">
                                        <span class="text-danger">Address Type is required.</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>Address</label><span class="text-danger"> * </span>
                                <div class="radio my-0">
                                    <label>
                                        <input
                                            #pvtOrPublic="ngModel"
                                            name="isGlobal"
                                            type="radio"
                                            [value]="false"
                                            [(ngModel)]="mapOriginDataModel.locationSelected.isGlobal"
                                        />Private
                                    </label>
                                    <label class="ml-4">
                                        <input
                                            #pvtOrPublic="ngModel"
                                            name="isGlobal"
                                            type="radio"
                                            [value]="true"
                                            [(ngModel)]="mapOriginDataModel.locationSelected.isGlobal"
                                        />Public
                                    </label>
                                    <label class="ml-4">
                                        <input
                                            #pvtOrPublic="ngModel"
                                            name="isGlobal"
                                            type="radio"
                                            [value]="null"
                                            [(ngModel)]="mapOriginDataModel.locationSelected.isGlobal"
                                        />Airport
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="mapOriginDataModel.locationSelected.isGlobal == null" class="row form-group">
                            <div class="col-md-6">
                                <label>Airport Code </label><span class="text-danger"> * </span>
                                <button
                                    *ngIf="!isShowAddAirportCode"
                                    id="addAirportCode"
                                    class="plus-icon"
                                    title="Add Airport Code"
                                    type="button"
                                    (click)="isShowAddAirportCode = true"
                                >
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                                <button
                                    *ngIf="isShowAddAirportCode"
                                    class="plus-icon"
                                    title="Cancel Add Airport Code"
                                    type="button"
                                    (click)="isShowAddAirportCode = false; airport = ''"
                                >
                                    <i class="fa fa-times-circle"></i>
                                </button>
                                <div *ngIf="isShowAddAirportCode">
                                    <div class="col-md-8 px-0">
                                        <input
                                            id="airport-code"
                                            class="form-control"
                                            #airportCode="ngModel"
                                            maxlength="4"
                                            name="airportCode"
                                            placeholder="Enter Airport Code"
                                            required
                                            type="text"
                                            [value]="airport | uppercase"
                                            [(ngModel)]="airport"
                                        />
                                    </div>
                                    <div class="col-md-4 pr-0">
                                        <button
                                            id="save-airport-code"
                                            class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                            type="submit"
                                            (click)="isShowAddAirportCode = false; addAirportCode()"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                                <select
                                    *ngIf="!isShowAddAirportCode"
                                    id="select-airport-code"
                                    class="form-control"
                                    #airportCode="ngModel"
                                    name="airportCode"
                                    required
                                    [ngClass]="{ 'is-invalid': addLocationForm.submitted && airportCode.invalid }"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.airportCode"
                                >
                                    <option disabled selected [value]="null">Select Airport Code</option>
                                    <option *ngFor="let item of airportCodeList" name="state" [value]="item.airportCode">
                                        {{ item?.airportCode }}
                                    </option>
                                </select>
                                <!--todo commented as no details for airportCode-->
                                <!--<div *ngIf="addLocationForm.submitted && airportCode && airportCode.invalid" class="invalid-feedback">
                  <div *ngIf="airportCode.errors.required">
                    <span class="text-danger">
                      Airport Code is required.
                    </span>
                  </div>
                </div>-->
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>Street Address</label><span class="text-danger"> * </span>
                                <input
                                    id="aContact_StreetAddress"
                                    class="form-control"
                                    #streetAddress="ngModel"
                                    disabled
                                    name="streetAddress"
                                    placeholder="Street Address"
                                    type="text"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.streetAddress"
                                />
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>ZipCode</label><span class="text-danger"> * </span>
                                <input
                                    id="ZipCode"
                                    class="form-control"
                                    #ZipCode="ngModel"
                                    disabled
                                    name="ZipCode"
                                    placeholder="ZipCode"
                                    type="text"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.zipCode"
                                />
                                <div *ngIf="addLocationForm.submitted && ZipCode.invalid" class="invalid-feedback">
                                    <div *ngIf="ZipCode.errors.pattern">
                                        <span class="text-danger">ZipCode not valid.</span>
                                    </div>
                                    <div *ngIf="ZipCode.errors.minlength">
                                        <span class="text-danger">ZipCode must have 3 or 5 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>State </label><span class="text-danger"> * </span>
                                <input
                                    id="state"
                                    class="form-control"
                                    #State="ngModel"
                                    disabled
                                    name="state"
                                    placeholder="State"
                                    type="text"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.state"
                                />
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>City </label><span class="text-danger"> * </span>
                                <input
                                    id="city"
                                    class="form-control"
                                    #City="ngModel"
                                    disabled
                                    name="city"
                                    placeholder="City"
                                    type="text"
                                    [(ngModel)]="mapOriginDataModel.locationSelected.city"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        id="cancel-edit-location"
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        data-dismiss="modal"
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        id="edit-location"
                        class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        type="submit"
                        (click)="editSelectedLocationName(addLocationForm)"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
